import './index.css';
import {useEffect} from "react";

function IosPageSm() {
    useEffect(() => {
        window.location.replace('https://milocal.cencosud.com/ios')
    }, []);

    return < >
        <div className="ios-page">
            <div className="content">
                <img src="assets/img/ios-sm/1.png" alt=""/>
                <a className="btndownload"
                   href="">
                    <img src="assets/img/ios-sm/2.png" alt=""/>
                </a>
                <img className="mb-2 card" src="assets/img/ios-sm/3.png" alt=""/>
                <img className="mb-2 card" src="assets/img/ios-sm/4.png" alt=""/>
                <img className="mb-2 card" src="assets/img/ios-sm/5.png" alt=""/>
                <img className="mb-2" src="assets/img/ios-sm/6.png" alt=""/>
            </div>
        </div>
    </>
}

export default IosPageSm;
